import { render, staticRenderFns } from "./teamMapping.vue?vue&type=template&id=630eb43a"
import script from "./teamMapping.vue?vue&type=script&lang=js"
export * from "./teamMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports